export class BaseParam {
    constructor() {
        this.page = 1;
        this.totalPages = 1;
        this.totalItems = 0;
        this.totalItemsWithoutFilters = 0;
        this.skipPagination = false;
        this.pageSize = 10;
        this.pageSizeOptions = [10, 20, 50];        
        this.ordering = new OrderParams();
        this.firstItemNumber = 1;
        this.lastItemNumber = 1;
        this.entityId = 0;
    }
}

export class OrderParams {
    constructor() {
        this.orderPropertyName = '';
        this.order = 1;
    }
}

export const PageSizeOptionsString = ["10", "20", "50"]



// WEBPACK FOOTER //
// ./src/APIModels/BaseParams.js